export default __webpack_public_path__ + "static/icons-paint-5f169d75ad7215005dd001f3e4f54f4f.png";